import {createSelector} from 'reselect';
import {IRootState} from '../root.types';

const selectTeam = (state:IRootState) => state.team;

export const selectTeamIsLoading = createSelector([selectTeam], state => state.isLoading);

export const selectTeamInfo = createSelector([selectTeam], state => state.team);